import React from "react";
import PropTypes from "prop-types";
import { Typography, Divider, Box, Grid} from "@mui/material";
import FormField from "./FormFields/FormField";
import FormTitle from "./FormFields/FormTitle"
import { useGroupFields } from "./FormFields/useGroupFields"

FormBuilder.propTypes = {
  formName: PropTypes.string,
  fields: PropTypes.array,
};

export default function FormBuilder({ formName, fields}) {
  const {getGroupedFields} = useGroupFields();
  const groupedFields = getGroupedFields(fields);

  return <>
    <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
      {formName}
    </Typography>
    <Box sx={{ mt: 1 }}>
      <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
      <Grid container spacing={1.5}>
        {groupedFields?.map((row) => (
          <Grid item key={row[0].formQuestionId + row[0].fieldName} container spacing={2} alignItems="stretch">
          <Grid container item spacing={2}>
              {row.map(field =>
                <Grid key={field?.formQuestionId + field?.fieldName} item xs={12} sm={field.columns < 12 ? 6 : 12} lg={field.columns || 12}>
                <FormTitle fieldAttributes={field} />
              </Grid>
            )}
          </Grid>
          <Grid container item spacing={2}>
              {row.map(field =>
              <FormField
                key={field?.formQuestionId + field?.fieldName}
                fieldName={field?.fieldName}
                fieldAttributes={field}
              />
            )}
          </Grid>
        </Grid>
        ))}
      </Grid>
    </Box>
  </>
}